var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLineDownGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.967 25.977L1.968 0H.032L.031 25.979z",
    fill: "#6CC04A",
    fillRule: "nonzero"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMnB4IiBoZWlnaHQ9IjI2cHgiIHZpZXdCb3g9IjAgMCAyIDI2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPHRpdGxlPmxpbmUtZG93bi1ncmF5PC90aXRsZT4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJsaW5lLWRvd24tZ3JheSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMzEwMDAsIC0wLjAwMDAwMCkiIGZpbGw9IiM2Q0MwNEEiIGZpbGwtcnVsZT0ibm9uemVybyI+CiAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjk2ODUwMCwgMTIuOTg5NTAwKSBzY2FsZSgtMSwgMSkgcm90YXRlKDkwLjAwMDAwMCkgdHJhbnNsYXRlKC0wLjk2ODUwMCwgLTEyLjk4OTUwMCkgIiBwb2ludHM9IjEzLjk1NiAxMy45NTcgLTEyLjAyMSAxMy45NTggLTEyLjAyMSAxMi4wMjIgMTMuOTU4IDEyLjAyMSI+PC9wb2x5Z29uPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+";
export { SvgLineDownGreen as ReactComponent };